import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

const ExtendReserveModal = ({ isOpen, onClose, onSubmit, isLoading, data }) => {
  const [days, setDays] = useState("");

  useEffect(() => {
    if (isOpen && data) {
      setDays(
        data.reserveHoldDays !== undefined && data.reserveHoldDays !== null
          ? String(data.reserveHoldDays)
          : ""
      );
    } else if (!isOpen) {
      setDays("");
    }
  }, [isOpen, data]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!days || isNaN(days) || Number(days) <= 0) return;
    onSubmit({ days: Number(days) });
  };

  return (
    <div className="flex fixed inset-0 z-50 justify-center items-center bg-black bg-opacity-50 transition-opacity">
      <div className="mx-4 w-full max-w-md bg-white rounded-2xl shadow-2xl transition-all transform">
        <div className="flex justify-between items-center px-6 py-4">
          <h3 className="font-sans text-xl font-bold text-gray-900">
            Extend Reserve Transaction
          </h3>

          <button
            onClick={onClose}
            className="text-gray-400 transition-colors hover:text-gray-600"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="px-6 pb-3">

          <div className="">
            <p className="mb-2 font-sans text-sm text-gray-500">
              Choose the number of days to extend the reserve for this transaction.
            </p>
            
            <div className="p-2 mb-3 bg-gray-100 rounded-lg">
              <p className="font-sans text-sm text-gray-500">
                Reference: <span className="font-semibold">{data?.reference}</span>
              </p>

              <p className="font-sans text-sm text-gray-500">
                Name: <span className="font-semibold capitalize">{data?.user?.firstName || ""} {data?.user?.lastName || ""}</span>
              </p>
            </div>
          </div>


          <div className="mb-6">
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Days for the reserve to be accessible
            </label>
            <input
              type="number"
              min="1"
              value={days}
              onChange={(e) => setDays(e.target.value)}
              className="px-4 py-3 w-full text-base rounded-xl border border-gray-300 transition-all outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
              placeholder="e.g. 30"
              required
            />
          </div>

          <div className="flex gap-3 justify-end items-center">
            <button
              type="button"
              onClick={onClose}
              className="px-5 py-2.5 text-sm font-bold text-gray-700 bg-white rounded-xl border-2 border-gray-200 transition-all hover:bg-gray-50 active:scale-95"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading || !days}
              className={`px-5 py-2.5 text-sm font-bold text-white bg-yellow-600 rounded-xl transition-all active:scale-95 ${isLoading || !days ? "opacity-50 cursor-not-allowed" : "hover:bg-yellow-700"
                }`}
            >
              {isLoading ? "Extending..." : "Extend Reserve"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ExtendReserveModal;
